module.exports = __webpack_public_path__ + "static/media/xsg.5c2697a1.svg";